import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { Icon } from 'bones/design-system/components/icons/Icon';
import { VoiceboxLogo } from 'bones/design-system/components/icons/VoiceboxLogo';
import { Heading } from 'bones/design-system/components/typography/Heading';

export const VoiceboxWelcome: React.VFC = () => {
  const { copy } = useVoiceboxSchema();

  return (
    <div className="vb-voicebox-welcome">
      <Icon IconComponent={VoiceboxLogo} size={96} theme="light" />
      <Heading
        className="vb-voicebox-welcome-title"
        size="4xl"
        weight="semibold"
      >
        {copy.drawer.empty.title}
      </Heading>
      <Heading className="vb-voicebox-welcome-subtitle" size="xl">
        {copy.drawer.empty.subTitle}
      </Heading>
    </div>
  );
};
